<template>
	<layout activeLabel="地址管理">
		<div class="btnGroup"><div class="btnTab active" @click="newAddress()">新增地址</div></div>
		<div class="deviceTable">
			<el-table :data="tableData" default-expand-all :row-class-name="tableRowClassName" style="width: 100%">
				<el-table-column align="center" min-width="100" label="地区" prop="ssq"></el-table-column>
				<el-table-column align="center" min-width="180" label="详细地址" prop="address"></el-table-column>
				<el-table-column align="center" label="操作" prop="desc">
					<template slot-scope="scope">
						<div class="btns">
							<span class="btn" @click="handleSee(scope.row)">查看</span>
							<span class="btn" @click="handleEdit(scope.row)">编辑</span>
							<span class="btn error" @click="handleDelete(scope.row)">删除</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="dialog-box">
			<el-dialog :show-close="false" :visible.sync="centerDialogVisible" width="50%" center>
				<div slot="title" class="dialog-tit" @click="centerDialogVisible = false"><i class="el-icon-close"></i></div>
				<el-form ref="form" :model="form" :rules="rules" label-width="80px">
					<el-form-item label="省" prop="provinceName"><el-input v-model="form.provinceName" placeholder="请输入类型id" /></el-form-item>
					<el-form-item label="市" prop="cityName"><el-input v-model="form.cityName" placeholder="请输入关联用户表id" /></el-form-item>
					<el-form-item label="区" prop="countyName"><el-input v-model="form.countyName" placeholder="请输入电工姓名" /></el-form-item>
					<el-form-item label="详细地址" prop="address"><el-input v-model="form.address" placeholder="请输入电工工作时长" /></el-form-item>
					<el-form-item label="联系人" prop="name"><el-input v-model="form.name" placeholder="请输入服务评分" /></el-form-item>
					<el-form-item label="电话" prop="phone"><el-input v-model="form.phone" placeholder="请输入服务价格/小时" /></el-form-item>
				</el-form>
			</el-dialog>
		</div>
		<el-dialog :visible="newFormVisible" width="600px" @close="newFormVisible = false">
			<div class="dialog-content">
				<el-form ref="ruleForm" label-width="120px" :model="ruleForm" :rules="rules">
					<el-form-item label="选择地区" prop="region">
						<el-cascader :props="props" v-model="ruleForm.region" :options="regionList" placeholder="请选择地区" @change="addressChange"></el-cascader>
					</el-form-item>
					<el-form-item label="详细地址" prop="address"><el-input v-model="ruleForm.address" placeholder="请输入详细地址"></el-input></el-form-item>
					<el-form-item label="联系人" prop="name"><el-input v-model="ruleForm.name" placeholder="请输入联系人"></el-input></el-form-item>
					<el-form-item label="电话" prop="phone"><el-input v-model="ruleForm.phone" placeholder="请输入电话"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" v-if="editId == ''" @click="saveAddress('ruleForm')">保存地址</el-button>
						<el-button type="primary" v-else @click="updateAddress('ruleForm')">保存地址</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</layout>
</template>

<script>
import layout from './index.vue';
import { adderssList } from '../../http/api/ordinary.js';
import { addAddress, updateAddress, delAdderss } from '../../http/api/user.js';
import { ProvinceList } from '../../http/factory/add-eme.js';
export default {
	name: 'address',
	components: {
		layout
	},
	data() {
		return {
			tableData: [],
			centerDialogVisible: false,
			form: {},
			ruleForm: {
				region: [],
				province: '',
				city: '',
				county: '',
				address: '',
				name: '',
				phone: ''
			},
			rules: {
				region: [
					{
						required: true,
						message: '请选择地区',
						trigger: 'change'
					}
				],
				address: [
					{
						required: true,
						message: '请输入详细地址',
						trigger: 'blur'
					}
				],
				name: [
					{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}
				],
				phone: [
					{
						required: true,
						message: '请输入电话',
						trigger: 'blur'
					}
				]
			},
			regionList: [],
			props: {
				label: 'label',
				value: 'id'
			},
			newFormVisible: false,
			editId: ''
		};
	},
	created() {
		this.getRegion();
		this.getList();
	},
	methods: {
		// 获取行政区
		getRegion() {
			ProvinceList().then(data => {
				this.regionList = data;
			});
		},
		//选中地址
		addressChange(value) {
			this.ruleForm.province = value[0];
			this.ruleForm.city = value[1];
			this.ruleForm.county = value[2];
		},
		//查看
		handleSee(row) {
			this.centerDialogVisible = true;
			this.form = row;
		},
		//列表
		getList() {
			adderssList().then(res => {
				this.tableData = res.rows;
				this.tableData.forEach(function(item, index) {
					item.ssq = item.provinceName + item.cityName + item.countyName;
				});
			});
		},
		// 新增
		newAddress() {
			this.editId = ''
			this.ruleForm = {
				region: [],
				province: '',
				city: '',
				county: '',
				address: '',
				name: '',
				phone: ''
			}
			this.newFormVisible = true;
		},
		saveAddress(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					addAddress({
						province: this.ruleForm.province,
						city: this.ruleForm.city,
						county: this.ruleForm.county,
						address: this.ruleForm.address,
						name: this.ruleForm.name,
						phone: this.ruleForm.phone
					}).then(res => {
						this.newFormVisible = false;
						this.getList()
						this.$message({
							message: '新增成功',
							type: 'success'
						});
					});
				}
			});
		},
		// 编辑地址
		handleEdit(row) {
			this.editId = row.id
			this.newFormVisible = true
			this.ruleForm = {
				region: [parseInt(row.province),parseInt(row.city),parseInt(row.county)],
				province: parseInt(row.province),
				city: parseInt(row.city),
				county: parseInt(row.county),
				address: row.address,
				name: row.name,
				phone: row.phone
			}
		},
		updateAddress(){
			updateAddress({
				province: this.ruleForm.province,
				city: this.ruleForm.city,
				county: this.ruleForm.county,
				address: this.ruleForm.address,
				name: this.ruleForm.name,
				phone: this.ruleForm.phone,
				id: this.editId
			}).then(res => {
				this.newFormVisible = false;
				this.getList()
				this.$message({
					message: '修改成功',
					type: 'success'
				});
			});
		},
		// 删除地址
		handleDelete(row) {
			console.log(row);
			delAdderss({
				id: row.id
			}).then(res => {
				this.getList();
				this.$message({
					message: '删除成功',
					type: 'success'
				});
			});
		},
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return 'warning-row';
			}
			return '';
		}
	}
};
</script>
<style lang="less" scoped>
.btnGroup {
	padding: 0 0.4rem 0.2rem;
	box-sizing: border-box;
	display: flex;
	flex-wrap: wrap;

	.btnTab {
		margin-top: 0.2rem;
		margin-right: 0.25rem;
		padding: 0.06rem 0.19rem;
		border-radius: 0.06rem;
		text-align: center;
		line-height: 0.2rem;
		font-size: 0.14rem;
		background: #ebebeb;
		color: #7d7d7d;
		cursor: pointer;

		&.active {
			color: #fff;
			background: #818181;
		}
	}
}

.deviceTable {
	padding: 0.1rem 0.4rem 0.4rem;
	box-sizing: border-box;
	min-height: 300px;
}

.deviceCard {
	padding-right: 1rem;
	padding-top: 0.48rem;
	box-sizing: border-box;
	display: flex;
}

.row-merge {
	padding: 0.18rem 0.33rem 0;
	display: flex;
	flex-wrap: wrap;

	&.order-row0 {
		background: #f2f2f2;
	}

	.order-item {
		width: 2.3rem;
		padding-bottom: 0.18rem;
		display: inline-flex;
		align-items: center;
	}

	.order-name {
		padding: 0 0.18rem;
		font-size: 0.14rem;
		color: #000;
	}
}

.logo {
	width: 0.38rem;
	min-width: 0.38rem;
	height: 0.38rem;
	border-radius: 0.07rem;
}

.nameBox {
	display: flex;
	align-items: center;

	.orderName {
		line-height: 0.38rem;
		padding-left: 0.14rem;
		color: #000;
		font-size: 0.14rem;
	}
}

.btns {
	.btn {
		padding: 0 0.16rem;
		color: #000;
		cursor: pointer;

		&.error {
			color: #f53232;
		}
	}
}

.time-line {
	.count {
		line-height: 0.2rem;
		padding-bottom: 0.09rem;
	}

	.status {
		color: #ff6b4a;
	}
}

/deep/ th .cell,
/deep/ tr .cell {
	color: #000;
	font-size: 0.14rem;
	font-weight: 500;
}

/deep/ .el-table__row {
	border-radius: 0.06rem;
}

/deep/ .el-table::before {
	height: 0 !important;
}

/deep/ .el-table .el-table__header .el-table__cell {
	padding: 8px;
}

/deep/ .el-table .el-table__header tr,
/deep/ .el-table .el-table__header tr th,
/deep/ .warning-row {
	background: #f6f6f6;
	border-radius: 0.06rem;
}

/deep/ .el-table td.el-table__cell,
/deep/ .el-table th.el-table__cell.is-leaf {
	border-bottom: unset;
}

.demo-table-expand {
	font-size: 0;
}

.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}

.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}

.dialog-box {
	font-size: 0;

	.dialog-tit {
		position: absolute;
		text-align: center;
		line-height: 0.47rem;
		width: 0.47rem;
		height: 0.47rem;
		right: -0.63rem;
		top: -0.1rem;
		background: #fff;
		border-radius: 50%;
		color: #000;
		font-size: 0.26rem;
		cursor: pointer;
	}

	/deep/ .el-table thead {
		color: #282828;
	}

	/deep/ .el-table .cell {
		font-size: 0.14rem;
	}

	/deep/ .el-dialog--center .el-dialog__body {
		padding-top: 0;
		padding-bottom: 1rem;
	}
}
</style>
